import React from "react";
import Banner from "./Banner";
import "./css/Home.css";



const Home = (props) => {

    const renderBanner = () => {
        if (props.isLoading === true) {
            return <div>Loading....</div>
        } else {
            return <Banner
                trxPrice={props.trxPrice}
                tokensAvailable={props.tokensAvailable}
                timeDifference={props.timeDifference}
                stage={props.stage}
                icoOver={props.icoOver}
                currency={props.currency}
            />
        }
    }

    return (
        <>
            {renderBanner()}
        </>
    )

}

export default Home;